import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from "framer-motion";
import HeroSection from './HeroSection';
import Footer from '../components/Footer';
import Socialicon from '../components/Socialicon';
import Feedback from '../components/feedback';
import { db, collection, getDocs } from '../components/firebase';
import SEO from '../components/SEO';
import AuthModal from './components/AuthModal';
import { useAuth } from '../context/AuthContext';
import { Tabs, TabsList, TabsTrigger } from '../components/ui/tabs';

import AdSense from '../components/AdSense';

const LandingPage = () => {
  const [activeTab, setActiveTab] = useState('studyhub');
  const [stats, setStats] = useState({ students: '10K+', materials: '500+', rating: '4.8' });
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleJoinClick = (path) => {
    if (isAuthenticated || path === '/ipu-result') {
      navigate(path);
    } else {
      navigate('/signup');
    }
  };

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const usersSnap = await getDocs(collection(db, 'Users'));
        const feedbackSnap = await getDocs(collection(db, 'feedback'));
        const postsSnap = await getDocs(collection(db, 'posts'));

        let avgRating = 4.8;
        if (feedbackSnap.size > 0) {
          const totalRating = feedbackSnap.docs.reduce((acc, d) => acc + (d.data().rating || 0), 0);
          avgRating = (totalRating / feedbackSnap.size).toFixed(1);
        }

        setStats({
          students: usersSnap.size > 1000 ? `${(usersSnap.size / 1000).toFixed(1)}K+` : `${usersSnap.size}+`,
          materials: `${postsSnap.size + 150}+`,
          rating: `${avgRating}`
        });
      } catch (e) {
        console.error("Error fetching stats:", e);
      }
    };
    fetchStats();
  }, []);

  return (
    <div className="bg-background min-h-screen text-foreground transition-all duration-300">
      <SEO
        title="B.Tech Notes, PYQs & IPU Results"
        description="Your complete study companion for GGSIPU B.Tech. Access premium notes, previous year papers, and real-time IPU results for CSE, AIML, AIDS, and IT."
        keywords="IPU B.Tech, GGSIPU Notes, SnapED, codeCampus, engineering notes, IPU Result 2024, B.Tech PYQ"
      />

      {/* Service Switcher */}
      <div className="fixed top-24 left-1/2 -translate-x-1/2 z-40 w-[90%] max-w-fit">
        <Tabs value={activeTab} onValueChange={(val) => {
          setActiveTab(val);
        }} className="w-full">
          <TabsList className="bg-card/50 backdrop-blur-xl border border-border p-1 rounded-full shadow-2xl h-12 md:h-14">
            <TabsTrigger value="studyhub" className="rounded-full px-6 py-2 text-xs md:text-sm font-bold data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-lg data-[state=active]:shadow-primary/20 transition-all">
              Study Hub
            </TabsTrigger>
            <TabsTrigger value="ipuchecker" className="rounded-full px-6 py-2 text-xs md:text-sm font-bold data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-lg data-[state=active]:shadow-primary/20 transition-all">
              IPU Results
            </TabsTrigger>
            <TabsTrigger value="jobportal" className="rounded-full px-6 py-2 text-xs md:text-sm font-bold data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-lg data-[state=active]:shadow-primary/20 transition-all">
              Job Portal
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </div>

      <div className="pt-[72px]">
        <div className="h-28 md:hidden" />
        <HeroSection stats={stats} mode={activeTab} onJoinClick={handleJoinClick} />
      </div>

      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
      />

      {/* Unified AdSense Component */}
      <AdSense slot="3954013251" className="my-8" />

      <Feedback />
      <Socialicon />
      <Footer />
    </div>
  );
};

export default LandingPage;
